import { commonViewTexts } from '../common';

export const createDialogCommonViewTexts = {
  messageGenerator: (title: string) => [
    `新しい${title}を登録します。`,
    '下記入力エリアに情報を入力し登録ボタンを押してください。'
  ],
  cancel: commonViewTexts.backToListPage,
  ok: commonViewTexts.register
};
